// extracted by css-extract-rspack-plugin
export default {"cls1":"OnboardingTour-cls1_4jq","cls2":"OnboardingTour-cls2_j8x OnboardingTour-cls1_4jq"};